import {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  detailsUnifSelector as detailSelectorFn,
  multiRoomArcInfo,
  isCartUpdatingStatusSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';
import * as S from './AddUpgradeRoomFlow.styles';
import {
  createPaxStringFromRoomTariffs,
  getAdultandChildTxt,
  getMultiRoomKey,
} from '@stencil/hotels-utils/src/common-utils';
import Modal, {useModal} from '@stencil/hotels-modal-component';
import BrandModalHeader from '../../../../../../../components/BrandModalHeader';
import {roomStringSelectorFn} from '@stencil/hotels-common-reducer/src/selectors';
import splitRoomString from '@stencil/hotels-utils/src/split-room-string';

export default function AddUpgradeRoomFlow({
  rtc,
  rpc,
  pk,
  pax,
  index,
  isAddBtnDisabled = false,
  onRoomCountUpdate,
  pwiDataItem,
  supplierCode,
}) {
  const {
    isModalOpen: isLessOccupancyModalOpen,
    openModal: openLessOccupancyModal,
    closeModal: closeLessOccupancyModal,
  } = useModal();
  let roomString = useSelector(roomStringSelectorFn);

  const {paxCount, childCount} = splitRoomString(roomString);

  const dispatch = useDispatch();
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [showUpgradeBtn, setShowUpgradeBtn] = useState(false);
  const [roomCount, setRoomCount] = useState(1);

  const isCartUpdating = useSelector(isCartUpdatingStatusSelector);
  const detailStoreData = useSelector(detailSelectorFn);
  const arcInfoObj = useSelector(multiRoomArcInfo);
  const {cartRequestPayload = {}, cartResponseData = {}} = detailStoreData;

  let paxString = createPaxStringFromRoomTariffs(pwiDataItem.roomTariffs);

  const key = getMultiRoomKey(rtc, pwiDataItem?.tariffCode, paxString);

  useEffect(() => {
    /**If Condition Checks if Room is Added in Cart then update the room Count,
      Else If Condition Checks if No Room exists for this PWI then set Count to 1 and show Add Button
    **/
    if (
      // cartResponseData?.success &&
      cartRequestPayload &&
      cartRequestPayload[key] &&
      cartRequestPayload[key]?.count
    ) {
      setShowUpgradeBtn(true);
      setRoomCount(cartRequestPayload[key]?.count);
    } else if (cartRequestPayload && !cartRequestPayload[key]) {
      setShowUpgradeBtn(false);
      setRoomCount(1);
    }
  }, [cartResponseData]);

  useEffect(() => {
    if (arcInfoObj.hasOwnProperty(rtc)) {
      let val = arcInfoObj[rtc];
      setIsBtnDisabled(val);
    } else {
      setIsBtnDisabled(false);
    }
  }, [arcInfoObj]);

  const showAddMinusWidget = () => {
    setShowUpgradeBtn(true);
  };

  const onAddClick = () => {
    // setShowUpgradeBtn(true);
    updateRoomObj(1, showAddMinusWidget);
  };

  const updateRoomObj = (rC, callbackFn = () => {}) => {
    const {
      defaultPriceKey,
      tariffCode,
      mtKey,
      pricingKey,
      priceMap = {},
      occupancydetails,
    } = pwiDataItem;
    let data = {};
    if (rC == 0) {
      data = null;
    } else {
      let candidateArray = [];
      let obj = {
        adultCount: occupancydetails?.numberOfAdults,
        childAges: occupancydetails?.childAges,
      };
      for (let i = 0; i < rC; i++) {
        candidateArray.push(obj);
      }
      data = {
        count: rC,
        roomCode: rtc,
        ratePlanCode: tariffCode,
        mtKey: mtKey,
        pricingKey: priceMap[defaultPriceKey]?.pricingKey,
        supplierCode,
        roomStayCandidates: candidateArray,
      };
    }
    let isTotalGuestExceed = onRoomCountUpdate(key, data, index);
    if (!isTotalGuestExceed) {
      setRoomCount(rC);
      callbackFn();
    } else {
      openLessOccupancyModal();
    }
  };

  return (
    <>
      {!showUpgradeBtn && (
        <S.AddBtnOuterWrapper>
          <S.AddBtn
            disabled={isAddBtnDisabled || isBtnDisabled || isCartUpdating}
            onClick={() => onAddClick()}
          >
            Add
          </S.AddBtn>
        </S.AddBtnOuterWrapper>
      )}

      {showUpgradeBtn &&
        (isCartUpdating ? (
          <S.UpgradeDowngradeBtn disabled={true}>
            <span>-</span>
            <span>{roomCount}</span>
            <span>+</span>
          </S.UpgradeDowngradeBtn>
        ) : (
          <S.UpgradeDowngradeBtn>
            <span
              onClick={() => {
                if (isCartUpdating) {
                  return;
                }
                if (roomCount > 1) {
                  setRoomCount(roomCount - 1);
                  updateRoomObj(roomCount - 1);
                } else {
                  updateRoomObj(roomCount - 1);
                  setShowUpgradeBtn(false);
                }
              }}
              style={{
                padding: '0px 8px',
              }}
            >
              -
            </span>
            <span>{roomCount}</span>
            <span
              onClick={() => {
                if (isCartUpdating) {
                  return;
                } else if (isBtnDisabled) {
                  alert('Maximum available room count reached');
                  return;
                } else {
                  // setRoomCount(roomCount + 1);
                  updateRoomObj(roomCount + 1);
                }
              }}
              style={{
                padding: '0px 8px',
              }}
            >
              +
            </span>
          </S.UpgradeDowngradeBtn>
        ))}
      <Modal
        isOpen={isLessOccupancyModalOpen}
        closeModal={closeLessOccupancyModal}
        modalStyles={{width: '600px'}}
      >
        <BrandModalHeader style={{padding: '2rem'}}>Review Your Selection</BrandModalHeader>
        <S.LessOccupnacyModalContent>
          <S.LessOccupnacyModalInfoText>
            You searched for {getAdultandChildTxt(paxCount, childCount)} but are trying to add rooms
            for more than {paxCount + childCount} Guest.
          </S.LessOccupnacyModalInfoText>
        </S.LessOccupnacyModalContent>
      </Modal>
    </>
  );
}
